import React from 'react'

export default function EmailTemplates() {
  return (
    <div>EmailTemplates</div>
  )
}
